/* eslint-disable no-case-declarations */
import get from 'lodash/get';
import last from 'lodash/last';
import { isEmpty, isPlainObject } from 'lodash';
import {
  GET_NEW_QUESTION,
  API_IN_PROGRESS,
  UPDATE_QUESTION_ANSWER,
  GET_NEW_QUESTION_START,
  GET_QUESTIONS_SUCCESS,
  SET_CURRENT_BREADCRUMB,
  GET_REVIEW_SUCCESS,
  GET_QUOTE_SUCCESS,
  GET_QUESTION_FAILURE,
  GET_DOCUMENT_SUCCESS,
  GET_PLAN_SUCCESS,
  GET_QUOTEREVIEW_SUCCESS,
  GET_SIGNATURE_SUCCESS,
  GET_PAYMENT_SUCCESS,
  GET_TIMEOUT_SUCCESS,
  GET_INACTIVESESSION_SUCCESS,
  GET_CHALLENGE_SUCCESS,
  GET_RIDERS_SUCCESS,
  GET_COMPLETED_SUCCESS,
  GET_LOGIN_SUCCESS,
  GET_KNOCKOUT_SUCCESS,
  GET_UNSUBSCRIBED_SUCCESS,
  GET_PRODUCTS_SUCCESS,
  GET_INTERVIEW_SUCCESS,
  GET_LAUNCH_SUCCESS,
  GET_REFERRAL_SUCCESS,
  GET_EHR_SUCCESS,
  GET_STATIC_SUCCESS,
  UPDATE_DATA_SELECTOR_OPTIONS,
  TOGGLE_ESIGN_BUTTON,
  UPDATE_LIST_SECTION,
  GET_PROCESSING_SUCCESS,
  GET_WELCOME_SUCCESS,
  GET_HEALTH_SUCCESS,
  SET_ACTION_MESSAGE,
  SET_PDF_CONFIGS,
  SET_POPUP_DETAILS,
  UPDATE_LAST_FOCUSED_ELEMENT_ID,
  CLOSE_USPS_MODEL,
  SHOW_USPS_MODEL,
  SET_COPYAPP_URL,
  SET_OUTER_LIST_ACTION_BUTTON,
  SET_CURRENT_EDITING_LIST_INDICES,
  RESET_CURRENT_EDITING_LIST_INDICES,
  UPDATE_QUESTION_ANSWER_TIME_STAMP,
  USPS_API_START,
  USPS_API_COMPLETE,
} from '../types';
import { getUTCTimestamp, isCustomRole, shiftFocusOnRouteChange } from '../../utils';
import HELPER, { getCurrentBreadcrumb } from './helper';
import {
  isListQuestion,
  getListDisplayMode,
  hasListItems,
  getAddButtonText,
  getQuestionStatus,
} from '../actions/listQuestionHelper';
import SessionStorageServices from '../../util/sessionStorageServices';

const initialState = {
  breadcrumbs: {
    currentBreadcrumb: {},
    isBreadcrumbLoaded: true,
    breadcrumbList: [],
  },
  isLoading: true,
  identity: null,
  lastFocusedElementId: '',
  routeChange: false,
  pageSubHeader: {},
  currentPageSeqNumber: 0,
  sectionIndex: 0,
  isListAddAction: false,
  listIndex: -1,
  listEditIndex: -1,
  listEditQId: '',
  activeSubsectionId: '',
  actionMessage: {
    type: '',
    message: '',
  },
  eSign: {
    pdfBlobURL: '/',
    pdfNumPages: null,
    hasESign: false,
    eSignEnable: false,
  },
  retry: {
    interval: 0,
  },
  loader: {
    message: 'Just a moment...',
  },
  popupQuestions: [],
  popupDetails: { show: false, question: '' },
  lastInteractedQuestion: {},
  lastSectionSubmittedAt: '',
  sections: {
    testSections: [
      {
        id: '12345',
        answersArray: [],
        errorsArray: [],
        answeredListArray: [],
        otherParams: {},
        errors: {},
        pageDesc: {},
        pageSeqNumber: 0,
        questionList: {},
        leftQuestionList: [],
        layoutRatio: {},
        requiredSchema: {},
        enableContinue: false,
        list: {
          isList: false,
          listDisplay: false,
          hasItems: false,
          addButtonText: 'Add',
          originalQuestions: [],
          questionObj: {},
        },
        audit: [],
        onload_timestamp: getUTCTimestamp(),
        questionObj: {},
      },
    ],
  },
  uspsConfig: {},
  addressRoute: [],
  addressFieldsMappingData: [],
  stateMappingData: [],
  editingParentListIndex: null,
  editingChildListIndex: null,
  isNestedListAddAction: false,
  enableOuterActionButton: true,
  editingSectionListIndex: null,
  editingParentListId: null,
  activeReviewedGroupId: null,
};

function updateBreadcrumbs(breadcrumbs = {}, payload) {
  const breadcrumbList = payload.reduce((acc, breadcrumb) => {
    acc.push({
      ...breadcrumb,
      id:
        breadcrumb.breadcrumb_id.toLowerCase() || breadcrumb.title.replace(/ /g, '').toLowerCase(),
    });
    return acc;
  }, []);
  return {
    ...breadcrumbs,
    breadcrumbList,
    currentBreadcrumb: getCurrentBreadcrumb(breadcrumbList),
    isBreadcrumbLoaded: true,
  };
}

function getLeftAndRightData(questionItem, skip, payload = {}) {
  const hasModal = get(payload, 'other_params.has_modal', false);
  const layout = get(questionItem, 'properties.layout', undefined);
  let leftQuestionList;
  let rightQuestionList;
  if (!skip && layout && layout.value === 'two_columns') {
    const allQuestions = get(questionItem, 'questions', []);
    for (let i = 0; i < allQuestions.length; i += 1) {
      const question = allQuestions[i];
      const displayPosition = get(question, 'properties.display_position.value', '');
      if (displayPosition === 'left') {
        leftQuestionList = HELPER.insertReflexiveQuestion(question, hasModal);
      } else if (displayPosition === 'right') {
        rightQuestionList = HELPER.insertReflexiveQuestion(question, hasModal);
      }
    }
    return {
      layoutRatio: layout.size,
      leftQuestionList,
      rightQuestionList,
    };
  }
  rightQuestionList = HELPER.insertReflexiveQuestion(questionItem, hasModal);
  return { layoutRatio: {}, leftQuestionList: [], rightQuestionList };
}

const appendOrientation = (questionObj, question) => {
  if (question?.properties?.orientation) return question;
  const orientation = get(questionObj, 'properties.orientation');
  if (orientation) {
    if (!question.properties || Array.isArray(question.properties)) {
      return { ...question, properties: { orientation } };
    }
    return {
      ...question,
      properties: {
        ...question.properties,
        orientation,
      },
    };
  }
  return question;
};

const getFormattedReviewResponse = (questionObj, reviewStatus = false) => {
  if (reviewStatus === false) return questionObj;

  const questionsList = [];
  if (questionObj && questionObj.length) {
    questionObj.forEach((ques) => {
      if (ques.display_type === 'questions_group') {
        const breadcrumbQuestions = ques.questions;
        // const breadcrumbGroup = { ...ques, questions: [] };
        // questionsList.push(breadcrumbGroup);
        questionsList.push(
          ...[
            {
              ...ques,
              isBreadcrumbCard: true,
              questions: [],
            },
            ...breadcrumbQuestions,
          ],
        );
      } else questionsList.push(ques);
    });
  }
  return questionsList;
};

const isReviewSection = (questionsList) => {
  if (questionsList && questionsList.length) {
    for (let i = 0; i < questionsList.length; i += 1) {
      if (questionsList[i].presentation_type === 'review') return true;
    }
  }
  return false;
};

const isReviewSatus = (status) => status === 'review' || status === 'quotereview';

function resetBreadcrumbData(action) {
  const { payload, type } = action;
  const currentStatus = get(payload, 'other_params.current_status', '');
  const role = get(payload, 'other_params.role', '');
  const questionObj = get(payload, 'data.questionnaire.questions', {});

  const layout = get(payload, 'data.questionnaire.questions.properties.layout.value');

  const isLeftRailQ =
    get(
      payload,
      'data.questionnaire.questions.questions[0].questions[1].properties.display_position.value',
    ) === 'left';

  let allQuestions = [];

  if (isLeftRailQ && isCustomRole(role) && currentStatus === 'quote') {
    allQuestions = get(
      payload,
      'data.questionnaire.questions.questions[0].questions[0].questions',
      [],
    );
    allQuestions = allQuestions.map((item) => {
      return appendOrientation(get(payload, 'data.questionnaire.questions'), item);
    });
  } else {
    allQuestions = get(payload, 'data.questionnaire.questions.questions', []);
  }

  const reviewStatus = isReviewSatus(currentStatus);
  allQuestions = getFormattedReviewResponse(allQuestions, reviewStatus);

  if (!Array.isArray(allQuestions)) return [];

  return allQuestions
    .filter((q) => !q.is_hidden)
    .map((questionItem, index) => {
      const { layoutRatio, rightQuestionList, ...rest } = getLeftAndRightData(
        questionItem,
        (type === GET_QUOTE_SUCCESS && layout !== 'two_columns') || reviewStatus,
        payload,
      );
      let { leftQuestionList } = rest;
      if (isLeftRailQ) {
        leftQuestionList = HELPER.insertReflexiveQuestion(
          get(payload, 'data.questionnaire.questions.questions[0].questions[1]', []),
        );
      }
      const requiredSchema = HELPER.getRequiredSchema(rightQuestionList);
      const isList = isListQuestion(rightQuestionList, reviewStatus);

      const originalQuestions = isList ? HELPER.getOriginalQuestions(questionItem) : [];
      const answersArray = HELPER.buildAnswersArray(rightQuestionList, originalQuestions);

      // Review Page Related Conditions
      const isReview = isReviewSection(rightQuestionList);
      const showReviewContinueButton = false;
      const listDisplay = getListDisplayMode(rightQuestionList);
      const questionStatus = getQuestionStatus(rightQuestionList);
      let enableContinue;
      if (reviewStatus) {
        enableContinue = true;
      } else {
        enableContinue = HELPER.shouldEnableContinue(
          requiredSchema,
          answersArray,
          [],
          isList,
          listDisplay,
          questionStatus,
        );
      }
      return {
        id: HELPER.getRandomId(),
        questionList: rightQuestionList,
        answeredListQuestion: HELPER.getAnsweredLisQuestionIds(rightQuestionList),
        leftQuestionList,
        layoutRatio,
        requiredSchema,
        answersArray,
        errorsArray: [],
        enableContinue,
        dataSelector: new Map(),
        otherParams: {
          ...payload.other_params,
        },
        errors: {
          ...payload.errors,
        },
        pageDesc: {
          ...payload.page_desc,
        },
        review: {
          isReview,
          showReviewContinueButton,
        },
        /**
         * Completed would be false for last section so last section
         * avoid sending index _modify_flag=1 this issue is caused
         * when resetBreadcrumbData called when answering reflexive
         * question in the last section in the
         * page NAT-1162
         */
        completed: allQuestions.length - 1 !== index,
        list: {
          isList,
          listDisplay,
          hasItems: hasListItems(rightQuestionList),
          addButtonText: getAddButtonText(rightQuestionList),
          questionObj: questionItem,
          originalQuestions,
        },
        questionObj,
        audit: [],
        onload_timestamp: getUTCTimestamp(),
      };
    });
}

/**
 * Function to compare the masked question's response (e.g SSN) from the
 * previous request and the upcoming response object.
 */
function compareMaskedResponse(breadcrumbQs = [], action) {
  let diff = false;
  let allQuestions = breadcrumbQs;
  const { payload, params, type } = action;
  const currentStatus = get(payload, 'other_params.current_status', '');
  const maskedQArray = get(params, 'maskedQArray', []);

  if (allQuestions.length === 0 || maskedQArray.length === 0) return false;

  const reviewStatus = isReviewSatus(currentStatus);
  allQuestions = getFormattedReviewResponse(allQuestions, reviewStatus);
  const layout = get(payload, 'data.questionnaire.questions.properties.layout.value');

  allQuestions.forEach((qItem) => {
    const { rightQuestionList } = getLeftAndRightData(
      qItem,
      type === GET_QUOTE_SUCCESS && layout !== 'two_columns',
      payload,
    );
    const isList = isListQuestion(rightQuestionList, reviewStatus);
    const originalQuestions = isList ? HELPER.getOriginalQuestions(qItem) : [];
    const answersArray = HELPER.buildAnswersArray(rightQuestionList, originalQuestions);
    if (answersArray.length > 1) {
      maskedQArray.forEach((arr) => {
        const ansArray = rightQuestionList.filter((q) => q.question_id === arr.question_id);
        if (ansArray.length) {
          if (ansArray[0].response !== arr.answer) diff = true;
        }
      });
    }
  });
  return diff;
}

/**
 * @description Compares current status with review status. Accepts either
 * current status or the payload.
 * @param {String} currentStatus
 * @param {Object} payload
 */
function isReviewPage(currentStatus, payload) {
  if (currentStatus) {
    return currentStatus === 'review' || currentStatus === 'quotereview';
  }
  const _currentStatus = get(payload, 'other_params.current_status', '');
  return _currentStatus === 'review' || _currentStatus === 'quotereview';
}

/**
 * @description function validates different conditions to determine
 * if breadcrumb data should be reset.
 * @param {Array} currentBreadcrumbData
 * @param {Object} action
 */
function shouldReset(currentBreadcrumbData = [], action = {}, routeChange = false) {
  try {
    const { payload, params } = action;
    const currentStatus = get(payload, 'other_params.current_status', '');
    const role = get(payload, 'other_params.role', '');
    const shouldReRender = get(payload, 'other_params.should_render', '');

    // Resets Breadcrumb Data for the following current_status routes
    const resetBreadcrumbRoutes = ['signature', 'completed'];
    const shouldResetRoutes =
      resetBreadcrumbRoutes.includes(currentStatus) ||
      (currentStatus === 'quote' && !isCustomRole(role));

    const isUpdateMode = get(payload, 'other_params.show_edit_page_flag', false);

    const allQs = [];
    HELPER.flattenQuestions(get(payload, 'data.questionnaire.questions.questions', []), allQs);
    const isTabSection =
      // currentStatus === 'questions' &&
      isCustomRole(role) && allQs.some((q) => q.question_type === 'tabs');

    /**
     * If the maskVariation is true then perform breadcrumb reset operation
     * else perform normal breadcrumb updation.
     */
    let maskVariation = false;
    if (params.maskedQArray) {
      const breadcrumbQs = get(payload, 'data.questionnaire.questions.questions', null);
      maskVariation = compareMaskedResponse(breadcrumbQs, action);
    }

    let breadcrumbQLength = get(payload, 'data.questionnaire.questions.questions', []).length;
    if (currentStatus === 'quote' && isCustomRole(role)) {
      breadcrumbQLength = get(
        payload,
        'data.questionnaire.questions.questions[0].questions[0].questions',
        [],
      ).length;
    }

    if (
      isReviewPage(currentStatus, payload) ||
      shouldResetRoutes ||
      isTabSection ||
      currentBreadcrumbData.length === 0 ||
      params.isReflexive ||
      params.validate ||
      params.breadcrumb_nav_flag ||
      params.prev_page_flag ||
      isUpdateMode ||
      maskVariation ||
      breadcrumbQLength < currentBreadcrumbData.length ||
      routeChange ||
      shouldReRender
    ) {
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
}
function updatedBreadcrumbData(currentBreadcrumbData = [], action, routeChange = false) {
  const { payload, params, type } = action;
  const questionObj = get(payload, 'data.questionnaire.questions', {});
  const currentStatus = get(payload, 'other_params.current_status');
  const role = get(payload, 'other_params.role');

  let breadcrumbQuestions = last(get(payload, 'data.questionnaire.questions.questions', null));

  if (shouldReset(currentBreadcrumbData, action, routeChange)) {
    return resetBreadcrumbData(action);
  }

  const isLeftRailQ =
    get(
      payload,
      'data.questionnaire.questions.questions[0].questions[1].properties.display_position.value',
    ) === 'left';

  if (isLeftRailQ && isCustomRole(role) && currentStatus === 'quote') {
    const breadcrumbQ = get(payload, 'data.questionnaire.questions');
    breadcrumbQuestions = appendOrientation(
      breadcrumbQ,
      last(get(breadcrumbQ, 'questions[0].questions[0].questions')),
    );
  }

  const hasModal = get(payload, 'other_params.has_modal', false);

  let questionList = [];
  if (breadcrumbQuestions) {
    let newBreadcrumbData = currentBreadcrumbData;
    const { isReflexive, sectionIndex } = params;
    if (isReflexive) {
      questionList = HELPER.insertReflexiveQuestion(breadcrumbQuestions, hasModal);
      newBreadcrumbData = HELPER.replaceSectionQuestion(
        currentBreadcrumbData,
        questionList,
        sectionIndex,
      );
      return newBreadcrumbData;
    }
    newBreadcrumbData = HELPER.removeDuplicate(currentBreadcrumbData, breadcrumbQuestions);
    const { layoutRatio, leftQuestionList, rightQuestionList } = getLeftAndRightData(
      breadcrumbQuestions,
      type === 'GET_QUOTE_SUCCESS',
      payload,
    );
    const requiredSchema = HELPER.getRequiredSchema(rightQuestionList);
    const listDisplay = getListDisplayMode(rightQuestionList);
    const listError = getQuestionStatus(rightQuestionList);

    let isList = false;
    if (Object.keys(layoutRatio).length === 0) {
      isList = isListQuestion(rightQuestionList, isReviewPage(null, payload));
    }

    const originalQuestions = isList ? HELPER.getOriginalQuestions(breadcrumbQuestions) : [];
    const answersArray = HELPER.buildAnswersArray(rightQuestionList, originalQuestions);

    return [
      ...newBreadcrumbData,
      {
        id: HELPER.getRandomId(),
        questionList: rightQuestionList,
        answeredListQuestion: HELPER.getAnsweredLisQuestionIds(rightQuestionList),
        leftQuestionList,
        layoutRatio,
        requiredSchema,
        answersArray,
        errorsArray: [],
        enableContinue: isReviewPage(null, payload)
          ? true
          : HELPER.shouldEnableContinue(requiredSchema, [], [], isList, listDisplay, listError),
        otherParams: {
          ...payload.other_params,
        },
        errors: {
          ...payload.errors,
        },
        pageDesc: {
          ...payload.page_desc,
        },
        list: {
          isList,
          listDisplay,
          hasItems: hasListItems(rightQuestionList),
          addButtonText: getAddButtonText(rightQuestionList),
          questionObj: breadcrumbQuestions,
          originalQuestions,
        },
        questionObj,
        audit: [],
        onload_timestamp: getUTCTimestamp(),
      },
    ];
  }
  return currentBreadcrumbData;
}

function listSectionUpdates(state = {}, listQIds) {
  const { errorsArray, answersArray, questionList } = state;
  let _errorsArray = [];
  let _answersArray = [];
  const listError = getQuestionStatus(questionList);
  _errorsArray = errorsArray.filter((item) => !listQIds.includes(item.question_id));
  _answersArray = answersArray.filter((item) => !listQIds.includes(item.question_id));
  return {
    ...state,
    errorsArray: _errorsArray,
    answersArray: _answersArray,
    enableContinue: !listError && _errorsArray.length === 0,
  };
}

// const getQuestionJson = (currentQuestion, questionId,questionJson=[]) => {
//   if (Array.isArray(currentQuestion) && currentQuestion.length) {
//     currentQuestion.forEach((question) => {
//       if (question?.question_id===questionId && !Array.isArray(question)) {
//         questionJson.push({
//           ...question,
//         });
//       }
//       if (get(question, 'questions', []).length) {
//         getQuestionJson(get(question, 'questions', []), questionId);
//       }
//     });
//   }
// };

// const getReflexiveStatus = (status, questionJson) => {
//   if (questionJson?.child_questions_on && questionJson?.question_type !== 'date') {
//     if(questionJson?.response && questionJson?.question_type==='multiselection'){
//       status = questionJson?.response.some((qu) => {
//         return questionJson?.child_questions_on.some((q) => q === qu?.id);
//       });
//     }else{
//       const response = questionJson?.response?.id ?? questionJson?.response;
//       status = questionJson?.child_questions_on.some((qu) => qu === response);
//     }
//   }
//   return status;
// };

const timeStampUpdates = (section = {}, action) => {
  const { questionId, timeStampData } = action.payload;
  const { transactionLog, lastSubmittedAt } = timeStampData;
  const answersArray = HELPER.addOrReplace(
    section.answersArray,
    { question_id: questionId, transactionLog, lastSubmittedAt },
    'transaction_log',
  );
  const questionList = HELPER.findAndUpdateTimeStamp(
    section.questionList,
    questionId,
    transactionLog,
    lastSubmittedAt,
  );
  return {
    ...section,
    answersArray,
    questionList,
  };
};

function questionUpdates(state = {}, action) {
  const {
    questionId,
    response,
    actualResponse,
    questionResponse,
    isError,
    isHidden,
    propQuestion,
    reset,
    isControlledInput,
    listParentId,
    listIndex,
    eSign,
    hasEdit,
    hasMask,
    auditRequired,
    isNestedQ,
    parentListIndex,
  } = action.payload;
  const answersArray = HELPER.addOrReplace(
    state.answersArray,
    {
      question_id: questionId,
      answer: response,
      is_reflexive: propQuestion ? propQuestion?.validations?.required?.is_reflexive : false,
      immediateParent: propQuestion ? propQuestion.immediateParent : '',
      parentId: propQuestion ? propQuestion.parentId : '',
      parentListQuestionId: get(action, 'payload.propQuestion.properties.parent_list_id', ''),
      reset,
      listParentId,
      listIndex,
      hasEdit,
      hasMask,
      parentListIndex,
      isNestedQ,
      actualResponse,
    },
    'answer',
  );

  const nList = questionId.match(/_\$ureify_/g);
  const skipUpdate = nList && nList.length === 2;
  const questionList = skipUpdate
    ? state.questionList
    : HELPER.addOrReplace(
        state.questionList,
        {
          question_id: questionId,
          is_hidden: isHidden || false,
        },
        'is_hidden',
      );
  const errorsArray = HELPER.addOrReplace(
    state.errorsArray,
    {
      question_id: questionId,
      isError,
    },
    'isError',
  ).filter((errorElement) => errorElement && errorElement.isError);

  let enableContinue = true;
  /**
   * isError is undefined when the page is reloaded
   * disable continue if there's any invalid question
   */
  if (!isError && questionList) {
    const allQuestions = [];
    const listQuestions = questionList.filter((q) => q.display_type === 'list') || [];
    listQuestions.forEach((qu) => {
      HELPER.flattenQuestions(qu.original_questions, allQuestions, true);
    });
    listQuestions.forEach((qu) => {
      if (Array.isArray(qu?.questions)) {
        qu.questions.forEach((q) => {
          HELPER.flattenQuestions(q, allQuestions, false);
        });
      }
    });
    const invalidListQs = allQuestions.filter(
      (question) =>
        get(question, 'question_status_message', '') ||
        get(question, 'question_status', '') === 'invalid',
    );
    const _invalidQs = questionList.filter((q) => {
      if (q.display_type === 'list') return q.question_status_message;
      return !q.is_hidden && q.question_status === 'invalid';
    });
    const invalidQs = [..._invalidQs, ...invalidListQs];
    for (let i = 0; i < invalidQs.length; i += 1) {
      const question = invalidQs[i];
      // when page is refreshed, push existing invalid questions into errorsArray
      // isError might be undefined for valid questions as well,
      // so checking if invalidQ is edited to valid answer(hasEdit: true) and
      // that question is not part of existing errorsArray
      if (
        isError === undefined &&
        !errorsArray.find((errQ) => errQ.question_id === question.question_id) &&
        !answersArray?.find((ansQ) => ansQ.question_id === question.question_id)?.hasEdit
      ) {
        errorsArray.push({
          question_id: question.question_id,
          isError: true,
          hasEdit,
          hasMask,
        });
      }
      // check if default invalid questions are answered as valid, if not make continue button disabled
      if (errorsArray.find((errQ) => errQ.question_id === question.question_id)) {
        enableContinue = false;
      }
    }
  }

  const currentStatus = get(action, 'payload.other_params.current_status', '');
  const isList = isListQuestion(state.questionList, currentStatus === 'review');
  const listDisplay = getListDisplayMode(state.questionList);
  const listError = getQuestionStatus(state.questionList);

  switch (action.type) {
    case UPDATE_QUESTION_ANSWER:
      return {
        ...state,
        questionList: HELPER.findAndUpdateResponse(
          questionList,
          questionId,
          response,
          questionResponse,
          isControlledInput,
        ),
        enableContinue:
          enableContinue &&
          HELPER.shouldEnableContinue(
            state.requiredSchema,
            answersArray,
            errorsArray,
            isList,
            listDisplay,
            listError,
            eSign,
          ),
        enableAdd: HELPER.shouldEnableContinue(state.requiredSchema, answersArray, errorsArray),
        audit: HELPER.insertAndUpdateTimestamp(state.audit, questionId, auditRequired),
        answersArray,
        errorsArray,
      };
    default:
      return state;
  }
}

function getSelectorOptions(parentQuestion, currentSelectedOptions, currentOption) {
  const responseOptions = get(parentQuestion.questions[0], 'response_options', []);
  const currentQuestionId = get(parentQuestion.questions[0], 'question_id', '');
  const sortedOption = [...currentOption].sort(HELPER.getSortOrder('target_question_id'));
  let isPresent = false;
  let dataSelectorOptions = currentSelectedOptions.get(currentQuestionId);
  let selectorIndex = -1;
  let count = 0;
  responseOptions.forEach((response) => {
    count = 0;
    const sortedResponse = [...response].sort(HELPER.getSortOrder('target_question_id'));
    for (let index = 0; index < sortedResponse.length; index += 1) {
      if (sortedResponse[index].response.value === sortedOption[index].response.value) {
        count += 1;
      }
    }
    if (count === sortedOption.length) {
      isPresent = true;
    }
  });
  if (Array.isArray(dataSelectorOptions)) {
    dataSelectorOptions.forEach((dataSelector, index) => {
      count = 0;
      const sortedResponse = [...dataSelector].sort(HELPER.getSortOrder('target_question_id'));
      if (sortedResponse.length === currentOption.length) {
        for (let i = 0; i < sortedResponse.length; i += 1) {
          if (sortedResponse[i].target_question_id === sortedOption[i].target_question_id) {
            count += 1;
          }
        }
        if (count === sortedOption.length) {
          selectorIndex = index;
        }
      }
    });
  } else {
    dataSelectorOptions = [];
  }
  if (selectorIndex > -1) {
    dataSelectorOptions.splice(selectorIndex, 1);
  }
  if (!isPresent) {
    dataSelectorOptions.push(currentOption);
    currentSelectedOptions.set(currentQuestionId, dataSelectorOptions);
  }
  return currentSelectedOptions;
}

function updateDataSelectorOptions(currentSection, action) {
  let currentDataSelector = currentSection.dataSelector;
  const currentOption = [];
  const { parentQuestion } = action.payload;
  const selectorOptions = get(parentQuestion.questions[0], 'selector_options', []);
  selectorOptions.forEach((option) => {
    const answersArray = HELPER.getAnswersArray(currentSection.answersArray, option.id);
    if (answersArray.length > 0) {
      currentOption.push({
        target_question_id: option.id,
        response: { value: answersArray[0].answer },
      });
    }
  });
  currentDataSelector = getSelectorOptions(parentQuestion, currentDataSelector, currentOption);
  const updatedSection = { ...currentSection };
  updatedSection.dataSelector = currentDataSelector;
  return updatedSection;
}

// function getContinueStatus(currentSection) {
//   const { questionList, requiredSchema, answersArray, errorsArray } = currentSection;
//   const enableContinue =
//     !hasInvalidQuestion(questionList) &&
//     HELPER.shouldEnableContinue(requiredSchema, answersArray, errorsArray);
//   return enableContinue;
// }

const getUSPSQuestions = (currentBreadcrumb) => {
  if (!currentBreadcrumb) return {};
  return currentBreadcrumb.reduce((acc, section, sectionIndex) => {
    section.questionList.forEach((q) => {
      const {
        type,
        sub_type: subType,
        response,
        question_id: questionId,
        field_name: fieldName,
      } = q;

      if (q && type === 'Validation' && subType === 'usps') {
        let answer = response;
        if (isPlainObject(answer) && answer.id) {
          answer = answer.id;
        }
        acc[fieldName] = { questionId, answer, sectionIndex };
      }
    });
    return acc;
  }, {});
};

const checkAndUpdateUSPSQuestions = (state, currentBreadcrumb, isReflexive) => {
  // check if usps questions present in new response
  const areUSPSQsPresentInResponse = currentBreadcrumb.some(
    (section) =>
      section?.questionList?.filter((q) => q?.type === 'Validation' && q?.sub_type === 'usps')
        ?.length > 0,
    [],
  );

  // if usps questions not present in new response, reset uspsConfig
  if (!areUSPSQsPresentInResponse) return {};

  // check if present usps questions in redux are empty
  const isUspsConfigEmpty = isEmpty(get(state, 'uspsConfig.uspsQuestions', {}));

  // if call is reflexive and usps questions present in redux
  // do not override them
  if (isReflexive && !isUspsConfigEmpty) return get(state, 'uspsConfig.uspsQuestions', {});

  return getUSPSQuestions(currentBreadcrumb);
};

export default function questions(state = initialState, action) {
  let routeChange = false;
  let currentBreadcrumb = null;
  let breadcrumbs = {};
  let currentPageSeqNumber = -1;
  let prevSections = [];
  let updatedSectionQuestions;
  let subSectionId;
  let actionMessage = {};
  let bannerInfo = '';
  let custCareTel = '';
  let policyExpiry = '';
  let reviseButtonLabel = '';
  let footerBanner = null;
  let footerNotes = [];
  let haveQuestions = {};
  let pageType = '';
  let { lastFocusedElementId } = state;
  let goolgePlaceConfigData = '';
  let addressRoute = [];
  let addressFieldsMappingData = [];
  let stateMappingData = [];
  let role = '';
  let hideBreadcrumbs = '';
  let currSection = [];
  const csrConfig = {
    rateClass: {
      enable: false,
      show: true,
    },
    quoteResults: {
      enable: false,
      show: true,
    },
    quoteSummary: {
      enable: false,
      show: true,
    },
  };
  const requoteCsrConfig = {
    rateClass: {
      enable: false,
      show: true,
    },
    quoteResults: {
      enable: false,
      show: true,
    },
    quoteSummary: {
      enable: false,
      show: true,
    },
  };
  const triggerValidation = [];
  let pageSubHeader = {
    applicationNumber: '',
    planName: '',
    coverageAmount: '',
    premiumFrequency: '',
    premiumAmount: '',
  };
  let isListAddAction = false;
  let isNestedListAddAction = false;
  let editingChildListIndex = null;
  let editingSectionListIndex = null;

  switch (action.type) {
    case GET_NEW_QUESTION_START:
      const isReflexOrNextCall =
        get(action, 'params.reflexive_question_flag', 0) === 1 ||
        get(action, 'params.next_page_flag', 0) === 1 ||
        get(action, 'params.index_modify_flag', 0) === 1 ||
        get(action, 'params.calculateClick', 0) === 1;
      return {
        ...state,
        isLoading: true,
        // isReflexiveQues:
        //   (action.params.next_page_flag ||
        //     action.params.index_modify_flag ||
        //     action.params.calculateClick),
        reload: action.params.reload,
        actionMessage: action.params.actionMessage,
        loadingSection: action.params.sectionIndex,
        isReflexive: action.params.isReflexive,
        lastSectionSubmittedAt: isReflexOrNextCall
          ? getUTCTimestamp()
          : state.lastSectionSubmittedAt,
        validate: action.params.validate,
        isListAddAction: action.params.isListAddAction,
        breadcrumbNavigation: action.params.breadcrumbNavigation,
        maskedQArray: action.params.maskedQArray,
        editingParentListIndex: null,
        editingChildListIndex: null,
        isNestedListAddAction: false,
        activeReviewedGroupId: action.params.activeReviewedGroupId,
        // listEditIndex: -1,
        // listEditQId: '',
      };
    case GET_NEW_QUESTION:
    case GET_QUESTIONS_SUCCESS:
    case GET_DOCUMENT_SUCCESS:
      bannerInfo = get(action, 'payload.data.questionnaire.questions.header', '');
      breadcrumbs = updateBreadcrumbs(state.breadcrumbs, get(action, 'payload.breadcrumbs'));
      currentBreadcrumb = breadcrumbs.currentBreadcrumb;
      currentPageSeqNumber = get(action, 'payload.data.questionnaire.page_sequence_number', -1);
      footerNotes = get(action, 'payload.data.questionnaire.questions.footer_notes', []);
      reviseButtonLabel = get(
        action,
        'payload.data.questionnaire.questions.revise_button_text',
        '',
      );
      haveQuestions = get(action, 'payload.data.questionnaire.questions.have_questions', {});
      routeChange = state.activeSubsectionId !== currentBreadcrumb.id;
      role = get(action, 'payload.other_params.role', '');
      if (routeChange) {
        lastFocusedElementId = '';
      }
      goolgePlaceConfigData = get(action, 'payload.google_places_config_data', '');
      addressRoute = get(goolgePlaceConfigData, 'route', []);
      stateMappingData = get(goolgePlaceConfigData, 'state_mapping_data', []);
      addressFieldsMappingData = get(goolgePlaceConfigData, 'address_fields_mapping_data', []);
      currSection = updatedBreadcrumbData(
        state.sections[currentBreadcrumb.id],
        // currentPageSeqNumber,
        action,
        routeChange,
      );
      pageSubHeader = {
        applicationNumber: get(action, 'payload.other_params.application_number', ''),
        planName: get(action, 'payload.other_params.plan_name', ''),
        coverageAmount: get(action, 'payload.other_params.coverage_amount', ''),
        premiumFrequency: get(action, 'payload.other_params.premium_frequency', ''),
        premiumAmount: get(action, 'payload.other_params.premium_amount', ''),
      };
      const subHeaderValues = Object.values(pageSubHeader);
      pageSubHeader.show = subHeaderValues.length && subHeaderValues.every((value) => value);
      hideBreadcrumbs = get(action, 'payload.other_params.hide_breadcrumbs', false);
      let activeReviewedGroupId = get(action, 'params.activeReviewedGroupId', null);
      // Fetch the credit card payment submission status
      const creditCardStatus = get(
        action,
        `payload.data.questionnaire.questions.questions[1].questions[${
          isCustomRole(role) ? 0 : 1
        }].questions[3].cybersource_status`,
        false,
      );

      const isReflexive = get(action, 'params.isReflexive', false);

      // Shift focus to respective element
      shiftFocusOnRouteChange({
        creditCardStatus,
        routeChange,
        isReflexive,
        activeReviewedGroupId,
      });

      return {
        ...state,
        bannerInfo,
        lastFocusedElementId,
        creditCardStatus,
        reviseButtonLabel,
        routeChange,
        role,
        csrConfig,
        requoteCsrConfig,
        triggerValidation,
        pageSubHeader,
        hideBreadcrumbs,
        currentPageSeqNumber,
        popupQuestions: get(action, 'payload.data.popup_questions', []),
        popupDetails: initialState.popupDetails,
        breadcrumbs,
        activeReviewedGroupId,
        activeSubsectionId: currentBreadcrumb.id,
        layout:
          get(action, 'payload.data.questionnaire.questions.properties.layout.value', 'double') ===
          'one_column'
            ? 'single'
            : '',
        sections: {
          ...state.sections,
          [currentBreadcrumb.id]: currSection,
        },
        footerNotes,
        haveQuestions,
        isLoading: false,
        retry: {
          ...state.retry,
          interval: get(action, 'payload.other_params.retry', 0),
        },
        loader: {
          ...state.loader,
          message: get(action, 'payload.other_params.message', 'Just a moment...'),
        },
        addressRoute,
        addressFieldsMappingData,
        stateMappingData,
        uspsConfig: {
          uspsQuestions: checkAndUpdateUSPSQuestions(state, currSection, isReflexive),
        },
      };

    case GET_QUOTE_SUCCESS:
    case GET_WELCOME_SUCCESS:
    case GET_HEALTH_SUCCESS:
    case GET_PLAN_SUCCESS:
    case GET_REVIEW_SUCCESS:
    case GET_QUOTEREVIEW_SUCCESS:
    case GET_SIGNATURE_SUCCESS:
    case GET_PAYMENT_SUCCESS:
    case GET_TIMEOUT_SUCCESS:
    case GET_INACTIVESESSION_SUCCESS:
    case GET_CHALLENGE_SUCCESS:
    case GET_RIDERS_SUCCESS:
    case GET_PROCESSING_SUCCESS:
    case GET_COMPLETED_SUCCESS:
    case GET_LOGIN_SUCCESS:
    case GET_KNOCKOUT_SUCCESS:
    case GET_UNSUBSCRIBED_SUCCESS:
    case GET_PRODUCTS_SUCCESS:
    case GET_INTERVIEW_SUCCESS:
    case GET_LAUNCH_SUCCESS:
    case GET_REFERRAL_SUCCESS:
    case GET_EHR_SUCCESS:
    case GET_STATIC_SUCCESS:
      bannerInfo = get(action, 'payload.data.questionnaire.questions.header', '');
      footerNotes = get(action, 'payload.data.questionnaire.questions.footer_notes', []);
      custCareTel = get(action, 'payload.data.questionnaire.questions.cust_care_tel', '');
      policyExpiry = get(action, 'payload.data.questionnaire.questions.policy_expiry_date', '');
      reviseButtonLabel = get(
        action,
        'payload.data.questionnaire.questions.revise_button_text',
        '',
      );
      footerBanner = get(action, 'payload.data.questionnaire.questions.footer_banner', null);
      pageType = get(action, 'payload.data.questionnaire.questions.question_id', '');
      haveQuestions = get(action, 'payload.data.questionnaire.questions.have_questions', {});
      subSectionId = get(action, 'payload.other_params.current_status', '');
      currentPageSeqNumber = get(action, 'payload.data.questionnaire.page_sequence_number', -1);
      goolgePlaceConfigData = get(action, 'payload.google_places_config_data', '');
      stateMappingData = get(goolgePlaceConfigData, 'state_mapping_data', []);
      addressFieldsMappingData = get(goolgePlaceConfigData, 'address_fields_mapping_data', []);
      routeChange = state.activeSubsectionId !== subSectionId;
      role = get(action, 'payload.other_params.role', '');
      if (routeChange) {
        lastFocusedElementId = '';
      }

      pageSubHeader = {
        applicationNumber: get(action, 'payload.other_params.application_number', ''),
        planName: get(action, 'payload.other_params.plan_name', ''),
        coverageAmount: get(action, 'payload.other_params.coverage_amount', ''),
        premiumFrequency: get(action, 'payload.other_params.premium_frequency', ''),
        premiumAmount: get(action, 'payload.other_params.premium_amount', ''),
      };
      const _subHeaderValues = Object.values(pageSubHeader);
      pageSubHeader.show = _subHeaderValues.length && _subHeaderValues.every((value) => value);

      // Shift focus to header telephone banner on routeChange
      const _headerTelEl = document.querySelector('[name="custom-header-banner"] a.tel');
      if (routeChange && _headerTelEl && _headerTelEl.focus) {
        _headerTelEl.focus();
      }

      activeReviewedGroupId = SessionStorageServices.getLocalValue('activeReviewedGroupId');
      if (activeReviewedGroupId) {
        SessionStorageServices.removeLocalValue('activeReviewedGroupId');
      }
      const reviewAction = get(action, 'params.action', null);
      if (activeReviewedGroupId && reviewAction) {
        shiftFocusOnRouteChange({
          creditCardStatus,
          routeChange,
          isReflexive,
          activeReviewedGroupId,
          reviewAction,
        });
      }

      return {
        ...state,
        bannerInfo,
        stateMappingData,
        addressFieldsMappingData,
        footerNotes,
        custCareTel,
        policyExpiry,
        reviseButtonLabel,
        footerBanner,
        lastFocusedElementId,
        routeChange,
        role,
        csrConfig,
        requoteCsrConfig,
        triggerValidation,
        pageSubHeader,
        activeSubsectionId: subSectionId,
        currentPageSeqNumber,
        breadcrumbs,
        popupQuestions: get(action, 'payload.data.popup_questions', []),
        popupDetails: initialState.popupDetails,
        isListAddAction: false,
        isNestedListAddAction: false,
        enableOuterActionButton: true,
        editingParentListIndex: null,
        sections: {
          ...state.sections,
          [subSectionId]: updatedBreadcrumbData(
            state.sections[subSectionId],
            // currentPageSeqNumber,
            action,
            routeChange,
          ),
        },
        isLoading: false,
        haveQuestions,
        pageType,
        retry: {
          ...state.retry,
          interval: get(action, 'payload.other_params.retry', 0),
        },
        loader: {
          ...state.loader,
          message: get(action, 'payload.other_params.message', 'Just a moment...'),
        },
      };

    case UPDATE_QUESTION_ANSWER:
      prevSections = state.sections;
      updatedSectionQuestions = questionUpdates(
        state.sections[action.activeSubsectionId][action.payload.sectionIndex],
        // state.currentPageSeqNumber,
        action,
      );
      // 'index' is used for updating the
      // last question and answer in a section
      prevSections[action.activeSubsectionId][action.payload.sectionIndex] =
        updatedSectionQuestions;

      // trigger field validation based on trigger_validation key from response
      const triggerQs = [];
      if (action.payload.triggerValidation && Array.isArray(action.payload.triggerValidation)) {
        action.payload.triggerValidation.forEach((triggerQ) => {
          const subSections = state.sections[action.activeSubsectionId];
          const answersArray = subSections?.[action.payload.sectionIndex]?.answersArray || [];
          const answQ = answersArray.find((q) => q.question_id === triggerQ);
          if (answQ && answQ.answer) {
            triggerQs.push(triggerQ);
          }
        });
      }
      return {
        ...state,
        sections: prevSections,
        csrConfig: {
          ...state.csrConfig,
          ...action.payload.csrConfig,
        },
        requoteCsrConfig: {
          ...state.requoteCsrConfig,
          ...action.payload.requoteCsrConfig,
        },
        triggerValidation: triggerQs,
      };

    // case UPDATE_QUESTION_ANSWER_IN_SOCKET:
    //   const currentSection = get(state, `sections[${state.activeSubsectionId}]`, []);
    //   let questionJson;
    //   let sequenceIn;
    //   currentSection?.find((q,index) => {
    //     questionJson = [];
    //     getQuestionJson(q?.questionList, action.payload.questionId, questionJson);
    //     sequenceIn=index;
    //     return questionJson.length > 0;
    //   });
    //   const errorsArray = get(currentSection, `${sequenceIn}.errorsArray`, []);
    //   const isReflexiveQues = getReflexiveStatus(action.payload.isReflexive, questionJson[0]);
    //   let questionStatus = 'missing';
    //   if (questionJson[0]?.response) {
    //     questionStatus = errorsArray.find((qu) => qu?.question_id === questionJson[0]?.question_id)
    //       ? 'invalid'
    //       : 'valid';
    //   }
    //   return {
    //     ...state,
    //     socketQuestion: {
    //         question_id: questionJson[0]?.question_id,
    //         transaction_log: questionJson[0]?.transaction_log,
    //         question_type: questionJson[0]?.question_type,
    //         question_status: questionStatus,
    //         num_times_answered: questionJson[0]?.num_times_answered,
    //         last_submitted_at: questionJson[0]?.last_submitted_at,
    //         stored_by:'browser_close',
    //       },
    //     isReflexiveQues,
    //   };

    case UPDATE_QUESTION_ANSWER_TIME_STAMP:
      prevSections = state.sections;
      const payloadSubsectionId = action.payload.activeSubsectionId;
      const payloadSectionIndex = action.payload.sectionIndex;
      if (!payloadSubsectionId || payloadSectionIndex < 0) {
        return {
          ...state,
          sections: prevSections,
        };
      }
      const activeSections = state.sections[payloadSubsectionId][payloadSectionIndex];
      updatedSectionQuestions = timeStampUpdates(activeSections, action);
      // // 'index' is used for updating the
      // // last question and answer in a section
      prevSections[payloadSubsectionId][payloadSectionIndex] = updatedSectionQuestions;
      return {
        ...state,
        sections: prevSections,
        lastInteractedQuestion: HELPER.findAndGetTimeStamp(
          updatedSectionQuestions.questionList,
          action.payload.questionId,
        ),
      };
    case UPDATE_LIST_SECTION:
      prevSections = state.sections;
      updatedSectionQuestions = listSectionUpdates(
        state.sections[action.activeSubsectionId][action.payload.sectionIndex],
        action.payload.listQIds,
      );
      prevSections[action.activeSubsectionId][action.payload.sectionIndex] =
        updatedSectionQuestions;
      return {
        ...state,
        sections: prevSections,
      };
    case UPDATE_DATA_SELECTOR_OPTIONS:
      prevSections = state.sections;
      updatedSectionQuestions = updateDataSelectorOptions(
        state.sections[action.activeSubsectionId][action.payload.sectionIndex],
        action,
      );
      return {
        ...state,
        sections: prevSections,
      };
    case API_IN_PROGRESS:
      return {
        ...state,
        isLoading: true,
        loadingSection: 0,
      };
    case 'UPDATE_IDENTITY_STATUS':
      return {
        ...state,
        identity: action.payload,
      };
    case SET_CURRENT_BREADCRUMB:
      return {
        ...state,
        breadcrumbs: {
          ...state.breadcrumbs,
          currentBreadcrumb: getCurrentBreadcrumb(state.breadcrumbs.breadcrumbList, action.id),
          breadcrumbList: state.breadcrumbs.breadcrumbList.map((breadcrumb) => {
            if (breadcrumb.id === action.id) {
              return {
                ...breadcrumb,
                active: true,
              };
            }
            return {
              ...breadcrumb,
              active: false,
            };
          }),
        },
      };
    case 'SET_LIST_INDEX':
      return {
        ...state,
        listIndex: action.index,
      };
    case 'SET_REFLEXIVE_LIST_INDEX':
      return {
        ...state,
        listEditIndex: action.index,
        listEditQId: action.id,
      };
    case GET_QUESTION_FAILURE:
    case SET_ACTION_MESSAGE:
      actionMessage = get(action, 'payload.actionMessage', {
        type: '',
        message: '',
      });
      return {
        ...state,
        isLoading: false,
        actionMessage: {
          type: actionMessage.type,
          message: actionMessage.message,
        },
      };
    case TOGGLE_ESIGN_BUTTON:
      // prevSections = state.sections;
      // updatedSectionQuestions = prevSections[state.activeSubsectionId][state.sectionIndex];
      // updatedSectionQuestions.enableContinue = getContinueStatus(updatedSectionQuestions);
      return {
        ...state,
        // sections: prevSections,
        eSign: {
          // ...state.eSign,
          hasESign: true,
          eSignEnable: action.enable,
        },
      };
    case SET_PDF_CONFIGS:
      return {
        ...state,
        eSign: {
          ...state.eSign,
          pdfBlobURL: action.url,
          pdfNumPages: action.pages,
        },
      };
    case SET_POPUP_DETAILS:
      return {
        ...state,
        popupDetails: action.payload,
      };
    case UPDATE_LAST_FOCUSED_ELEMENT_ID:
      return {
        ...state,
        lastFocusedElementId: get(action, 'payload.id', ''),
      };
    case USPS_API_START:
      return {
        ...state,
        isLoading: true,
        loadingSection: action.payload.sectionIndex,
        reload: action.payload.reload,
      };
    case USPS_API_COMPLETE:
      return {
        ...state,
        isLoading: false,
      };
    case SHOW_USPS_MODEL:
      return {
        ...state,
        uspsConfig: {
          ...state.uspsConfig,
          showUSPSAddressModel: true,
          uspsNextPage: action.payload.uspsNextPage,
          options: action.payload.options,
        },
      };
    case CLOSE_USPS_MODEL:
      return {
        ...state,
        uspsConfig: {
          showUSPSAddressModel: false,
          uspsQuestions: {},
        },
      };
    case SET_COPYAPP_URL:
      return {
        ...state,
        copyAppConfig: {
          redirectUrl: action.payload,
        },
      };
    case SET_OUTER_LIST_ACTION_BUTTON:
      const { shouldEnable } = action.payload;
      editingSectionListIndex = Number.isInteger(action.payload.sectionIndex)
        ? action.payload.sectionIndex
        : state.editingSectionListIndex;
      return {
        ...state,
        enableOuterActionButton: shouldEnable,
        editingSectionListIndex,
      };
    case SET_CURRENT_EDITING_LIST_INDICES:
      const { isAddAction, listParentId } = action.payload;
      isListAddAction = state.isListAddAction;
      isNestedListAddAction = state.isNestedListAddAction;
      const { sections } = state;
      if (isAddAction) {
        isListAddAction = !Number.isInteger(action.payload.editingChildListIndex);
        isNestedListAddAction = !isListAddAction;
        editingSectionListIndex = action.payload.editingSectionListIndex;
        sections[state.activeSubsectionId][editingSectionListIndex].answeredListQuestion = [];
      }
      editingChildListIndex = action.payload.editingChildListIndex;
      return {
        ...state,
        sections,
        editingChildListIndex: Number.isInteger(editingChildListIndex)
          ? editingChildListIndex
          : state.editingChildListIndex,
        editingParentListIndex: action.payload.editingParentListIndex,
        editingSectionListIndex: action.payload.editingSectionListIndex,
        editingParentListId: listParentId,
        isListAddAction,
        isNestedListAddAction,
      };
    case RESET_CURRENT_EDITING_LIST_INDICES:
      return {
        ...state,
        editingChildListIndex: null,
        editingParentListIndex: null,
        editingSectionListIndex: null,
        editingParentListId: null,
        enableOuterActionButton: true,
      };
    default:
      return state;
  }
}
